import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Combines and merges class names with conflict resolution for Tailwind CSS.
 *
 * This utility combines the functionality of `clsx` for conditional class construction
 * and `tailwind-merge` for intelligent Tailwind class conflict resolution.
 *
 * @example
 * ```ts
 * // Conditional classes
 * cn('base-class', { 'active-class': isActive, 'disabled-class': isDisabled })
 *
 * // Conflict resolution - later classes override earlier ones
 * cn('bg-red-500', 'bg-blue-500')
 * // => 'bg-blue-500'
 * ```
 *
 * @param inputs - Class values that can be strings, objects, arrays, or conditional expressions
 * @returns A single merged class name string with conflicts resolved
 */
export const cn = (...inputs: ClassValue[]) => twMerge(clsx(inputs));
